import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router';

import { TUseNavigationLoaderOptions } from '@/shared/hooks/use-navigation-loader/use-navigation-loader.types';

const DEFAULT_LOADER_DISPLAY_DELAY = 500;

export const useNavigationLoader = ({
  delay = DEFAULT_LOADER_DISPLAY_DELAY,
}: TUseNavigationLoaderOptions = {}) => {
  const navigation = useNavigation();
  const [displayNavigationLoader, setDisplayNavigationLoader] = useState(false);

  useEffect(() => {
    if (navigation.state === 'idle') {
      setDisplayNavigationLoader(false);
      return;
    }

    const timer = setTimeout(() => {
      setDisplayNavigationLoader(true);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay, navigation.state]);

  return displayNavigationLoader;
};
